lmApp
  .service('ToastService', ['$rootScope', '$templateCache', '$compile', '$timeout',
    function ($rootScope, $templateCache, $compile, $timeout) {

      var toastScope = $rootScope.$new(true);

      toastScope._bigToast_ = $templateCache.get('lm-toast/lm-big-toast.tpl.html');
      toastScope._bigToast_ = $compile(toastScope._bigToast_)(toastScope);
      toastScope._smallToast_ = $templateCache.get('lm-toast/lm-small-toast.tpl.html');
      toastScope._smallToast_ = $compile(toastScope._smallToast_)(toastScope);

      toastScope.bigToast = {};
      toastScope.smallToast = {};

      angular.element('body').append(toastScope._bigToast_);
      angular.element('body').append(toastScope._smallToast_);

      var _ShowBigToast = function (data, delay) {
        if (toastScope.bigToast.timeout) {
          _HideBigToast();
        }

        toastScope._bigToast_.css({
          'display': 'inline-block'
        });

        $timeout(function () {
          toastScope.bigToast = {
            color: data.color,
            title: data.title || '',
            icon: data.icon,
            show: true
          }
        });

        toastScope._bigToast_.find('#toast-text').html(data.text || '');

        toastScope.bigToast.timeout = $timeout(function () {
          $timeout(function () {
            toastScope.bigToast.show = false;
          });
        }, delay || 60 * 1000);
      };

      var _HideBigToast = function () {
        $timeout.cancel(toastScope.bigToast.timeout);
        $timeout(function () {
          toastScope.bigToast.show = false;
        });
      };

      toastScope.hideBigToast = function () {
        if (!toastScope.bigToast.blocked) _HideBigToast();
      };

      var _ShowSmallToast = function (data, delay) {
        if (toastScope.smallToast.timeout) {
          _HideSmallToast();
        }

        toastScope._smallToast_.css({
          'display': 'inline-block'
        });

        $timeout(function () {
          toastScope.smallToast = {
            color: data.color,
            title: data.title || '',
            icon: data.icon,
            blocked: data.blocked,
            show: true
          }
        });

        toastScope.smallToast.timeout = $timeout(function () {
          $timeout(function () {
            toastScope.smallToast.show = false;
          });
        }, delay || 10 * 1000);
      };

      var _HideSmallToast = function () {
        $timeout.cancel(toastScope.smallToast.timeout);
        $timeout(function () {
          toastScope.smallToast.show = false;
        });
      };

      toastScope.hideSmallToast = function () {
        _HideSmallToast();
      };

      return {
        Big: _ShowBigToast,
        Small: _ShowSmallToast,
        HideBig: _HideBigToast,
        HideSmall: _HideSmallToast
      }
    }]);
